import React from 'react';
import CheckboxGenerico from '../../../components/CheckboxGenerico';
import InputLabel from '@mui/material/InputLabel';
import Chip from '@mui/material/Chip';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import Divider from '@mui/material/Divider';

export default function DetalleNotificaciones({rows, listConfig, setListConfig}) {

    const handleCheckbox=(index, isChecked)=>{
        console.log('Lista Original, ', listConfig);
        console.log(`El check ${index} es: ${isChecked}`);
        let indexSplit =  index.split('_');
        let idNotificacionTipo = parseInt(indexSplit[1]);
        let tipoNotificacion = indexSplit[0];

        const lista = listConfig.map((item) => {
          if (idNotificacionTipo === item.idNotificacionTipo){
            if (tipoNotificacion === 'push'){
              return {
                ...item,
                push: isChecked
              }
            }
            else{
              return {
                ...item,
                email: isChecked
              }  
            }
          }else{
            return {
              ...item
            }
          }
        });
  
        setListConfig(lista);      

      } 


   

    return (
        rows.map((item, index) => (
            <>         
            <div>
                <div>
                    <InputLabel style={ { fontWeight: 'bold', color: 'black'} }>{item.titulo}</InputLabel>                 
                    <InputLabel>{item.descripcion}
                    {/* {item.obligatorio && <PriorityHighIcon />} */}
                    {item.obligatorio && <Chip label="Obligatoria" color="success" style={ { height: 'auto', marginLeft: '10px'}}/>}
                    </InputLabel>  
                   
                    <div style={ {float: 'right', display: 'inline-flex' , position: 'relative', top: '-30px', right: '5px'} }> 
                        <CheckboxGenerico initialState={item.email} 
                                        id={`mail_${item.idNotificacionTipo}`} 
                                        onChange={handleCheckbox} 
                        />              
                        <CheckboxGenerico initialState={item.push} 
                                        id={`push_${item.idNotificacionTipo}`} 
                                        onChange={handleCheckbox} 
                        />
                     </div> 
                </div>    
            </div>  
        </>                                                    
        ))    
)};


